import { useContext } from "react";

import { VisitorTrackingContext } from "@/providers/visitor-tracking-context";

export function useVisitorTracking() {
  const ctx = useContext(VisitorTrackingContext);
  if (!ctx) {
    throw new Error(
      "useVisitorTracking must be used within VisitorTrackingProvider",
    );
  }
  return ctx;
}
